(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/fuente/investigacion";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/fuente/fuente",
            controller: 'FuenteAdminController',
            controllerForm: 'FuenteFormAdminController',
            translateBase: "admin.fuente.investigacion."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
            },
            resolve: {
                tipo: function () {
                    return 'INVESTIGACION'
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: {
                /* @ngInject */
                itemData: function (FuenteTesauro) {
                    return new FuenteTesauro();
                }
            }
        });
        // Editar
        angular.merge(state.edit, {
            resolve: {
                /* @ngInject */
                itemData: function (FuenteTesauro, $stateParams) {
                    return FuenteTesauro.get({id: $stateParams.id}).$promise;
                }
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
